import { FluxType } from 'flux/buildFlux';
import { Observable } from 'rxjs';
import Logger from 'utils/Logger';
import { LocationInfo } from '~/cordovaPlugins/Location';
import {
  Permissions,
  permissions,
  permissions$,
} from '~/cordovaPlugins/Permissions';

/**
 * The services are not allowed to directly talk to react.
 * services can be expose observables which the UI can use.
 * Services cannot call for permissions (ios or android) themselves,
 * they must listen to the permissions$ and only start when possible.
 * @param flux
 */
export interface AppServices {
  location$: Observable<LocationInfo>;
  locationFunctions: {
    getLocation: () => Promise<LocationInfo>;
  };
  permissions$: Observable<Permissions>;
  permissionFunctions: {
    startPush: () => Promise<boolean>;
    requestLocationBackgroundPermission: () => Promise<boolean>;
    requestLocationInUsePermission: () => Promise<boolean>;
    requestHighAccuracyLocationPermission: () => Promise<boolean>;
    askForLocationPermissionsAfterDenial(): Promise<boolean>;
  };
  keyboard: {
    resetKeyboard: () => void;
    useLongFormKeyboard: () => void;
    useSimpleKeyboard: () => void;
  };
  destroy: () => void;
}
export interface ServiceProps {
  permissions$: Observable<Permissions>;
  flux: FluxType;
  updatePermissions: () => void;
}
export type Service<T> = (props: ServiceProps, extra?: any) => T;

export abstract class WlService {
  protected permissions$: Observable<Permissions> = permissions$;

  protected location$: Observable<LocationInfo>;

  protected props: ServiceProps;

  readonly services: AppServices;

  constructor(protected flux: FluxType) {
    this.props = {
      flux,
      permissions$: this.permissions$,
      updatePermissions: this.updatePermissions,
    };
  }

  protected updatePermissions() {
    // retrieve permissions
    permissions();
  }

  protected start<T>(name: string, service: Service<T>, extraParams?: any) {
    try {
      Logger.log(`Service.${name} starting`);
      return service(this.props, extraParams);
    } catch (e) {
      console.error(`Service.${name}`, e);
      return null;
    }
  }
}
